/**
 * InfoContent
 *
 * Content component for info sheet with a single Ok button.
 */

import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { SheetService } from '../../service/SheetService';
import { CTAButtons } from '../../service/components/CTAButtons';
import type { InfoSheetConfig } from '../InfoSheet';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { qaAttr } from '@/presentation/utils/qaAttr';

export interface InfoContentProps {
  config: InfoSheetConfig;
  onClose: () => void;
}

export const InfoContent: React.FC<InfoContentProps> = ({ config, onClose }) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();
  const { l10n } = useLocale();

  const handleOk = () => {
    onClose();
    SheetService.close();
  };

  return (
    <div {...(config.qaId ? qaAttr({ id: config.qaId }) : {})}>
      {/* Title */}
      <div
        style={{
          padding: responsive.spacing['2xl'],
          paddingBottom: 0,
          textAlign: 'center',
          color: theme.text.primary,
          fontSize: responsive.font.lg,
          fontWeight: responsive.fontWeight.semibold,
        }}
      >
        {config.title}
      </div>

      {/* Info text */}
      <div
        style={{
          padding: responsive.spacing['2xl'],
          textAlign: 'center',
          color: theme.text.primary,
          fontSize: responsive.font.base,
          lineHeight: 1.5,
        }}
      >
        {config.infoText}
      </div>

      {/* Single Ok button */}
      <CTAButtons
        cta={{
          buttons: [
            {
              text: config.okText || l10n.common.ok,
              onClick: handleOk,
              textColor: theme.exclusive,
              qaId: 'info-sheet-dismiss',
            },
          ],
        }}
        onClose={() => {}}
      />
    </div>
  );
};
